import {createWebHashHistory, createRouter} from 'vue-router';
import SurveyRoot from "@/components/SurveyRoot";
import ResultsContainer from "@/components/ResultsContainer";
import Error404 from "./components/Error404"


const routes = [
    {
        path: "/",
        name: "Root",
        component: SurveyRoot
    },
    {
        path: "/results",
        name: "Results",
        component: ResultsContainer,
    },
    {
        path:"/404",
        name:"Error404",
        component: Error404,
    }
]

const router = createRouter({
    history: createWebHashHistory("/apps/wsd"),
    routes
});

export default router;